import { render, staticRenderFns } from "./PortalLogin.vue?vue&type=template&id=bb241e18&scoped=true&"
import script from "./PortalLogin.vue?vue&type=script&lang=js&"
export * from "./PortalLogin.vue?vue&type=script&lang=js&"
import style0 from "./PortalLogin.vue?vue&type=style&index=0&id=bb241e18&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb241e18",
  null
  
)

export default component.exports